import { render, staticRenderFns } from "./AppendixRenewalSim.vue?vue&type=template&id=60605e48"
import script from "./AppendixRenewalSim.vue?vue&type=script&lang=js"
export * from "./AppendixRenewalSim.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports